import { Dispatch, HTMLAttributes, SetStateAction } from "react";
import { Dialog, DialogContent, DialogHeader } from "../ui/dialog";
import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { t } from "i18next";
import { Subtitle, Title } from "../Text";

const ChoiceContainer = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      "bg-gray-50 border border-gray-200 px-5 py-8 rounded-md h-full flex flex-col gap-8 items-center justify-center",
      className,
    )}
    {...props}
  />
);

export const AddArtworkChoiceDialog = ({
  open,
  onOpenChange,
  onChoseUseArtmatch,
  onChoseUseNewArtwork,
}: {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  onChoseUseArtmatch: () => void;
  onChoseUseNewArtwork: () => void;
}) => {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="min-w-fit w-fit">
        <DialogHeader />
        <div className="grid grid-cols-[1fr_auto_1fr] gap-8 items-center">
          <ChoiceContainer>
            <Title>{t("addArtworkChoice.artmatch.title")}</Title>
            <Subtitle>{t("addArtworkChoice.artmatch.subtitle")}</Subtitle>
            <Button variant={"default"} onClick={onChoseUseArtmatch}>
              {t("addArtworkChoice.artmatch.button")}
            </Button>
          </ChoiceContainer>
          <div>{t("addArtworkChoice.separation")}</div>
          <ChoiceContainer>
            <Title>{t("addArtworkChoice.new.title")}</Title>
            <Button variant={"default"} onClick={onChoseUseNewArtwork}>
              {t("addArtworkChoice.new.button")}
            </Button>
          </ChoiceContainer>
        </div>
      </DialogContent>
    </Dialog>
  );
};
